import { useCallback, useEffect } from 'react'
import { useSetState } from 'react-use'

import type { RelationRecordSelectProps } from './types'

interface RelativeDatasourceState {
    loading: boolean
    initLoading: boolean
    keywords: string
}

export const useRelativeDatasource = function (
    params: Pick<RelationRecordSelectProps, 'id' | 'onFetchDataSource' | 'onLoadMoreData' | 'dsId' | 'opened'>
) {
    const { id, onFetchDataSource, onLoadMoreData, dsId, opened } = params

    const [state, setState] = useSetState<RelativeDatasourceState>({
        loading: false,
        initLoading: true,
        // noNexData: false,
        keywords: ''
    })
    const { keywords } = state

    const handleFetchData = useCallback(
        async (search?: string) => {
            if (onFetchDataSource) {
                await onFetchDataSource({ id, dsId, pagination: { currentPage: 1, pageSize: 50 }, search })
                setState({ initLoading: false })
            }
        },
        [dsId, id, onFetchDataSource, setState]
    )

    const handleLoadMoreData = useCallback(
        async (page: number) => {
            setState({ loading: true })
            await onLoadMoreData?.({
                id,
                dsId,
                pagination: { currentPage: page, pageSize: 50 },
                search: keywords
            })
            setState({ loading: false })
        },
        [dsId, id, keywords, onLoadMoreData, setState]
    )

    const handleChangeSearch = useCallback(
        (value: string) => {
            if (value === '') {
                handleFetchData('')
            }
            setState({ keywords: value })
        },
        [handleFetchData, setState]
    )

    const handleChangeInitLoading = useCallback(
        (value: boolean) => {
            setState({ initLoading: value })
        },
        [setState]
    )

    useEffect(() => {
        if (!opened) {
            setState({ keywords: '' })
        }
    }, [opened, setState])

    return { state, handleLoadMoreData, handleFetchData, handleChangeSearch, handleChangeInitLoading }
}
